'use client'

import React, { JSX } from 'react'
import createWidget from '@/widgets/create-widget'
import { PhotoIcon } from '@heroicons/react/24/solid'
import NoticeBannerSchema, {
  NoticeBannerProps,
  NoticeBannerDefaultValues,
  NoticeBannerWidgetProps,
} from './schema'
import NoticeBanner from '@/components/RevampedLanding/NoticeBanner'

export function NoticeBannerWidget(props: NoticeBannerWidgetProps) {
  const { noticeBanner } = props
  return <NoticeBanner noticeBannerData={noticeBanner} />
}

export default createWidget<NoticeBannerWidgetProps>({
  formType: NoticeBannerSchema,
  render(props): JSX.Element {
    return <NoticeBannerWidget {...props} />
  },
  id: 'Landing.Page.NoticeBanner',
  name: 'Landing Notice Banner',
  icon: <PhotoIcon className='w-10 h-10' />,
  defaultProps: NoticeBannerDefaultValues,
})
